import { selectCurrentOrganization } from 'src/v2/domains/user/selectors/user.selectors'
import { useAppDispatch, useAppSelector } from 'src/v2/store/hooks'

import { navigateToRoute } from '../actions/routing.actions'
import {
  NavigationOptions,
  RouteKey,
  RouteParams,
} from '../types/routing.types'
import { buildRoute } from '../utils/route.utils'

export const useAppNavigation = () => {
  const dispatch = useAppDispatch()
  const currentOrganization = useAppSelector(selectCurrentOrganization)

  const navigateTo = <T extends RouteKey>(
    routeKey: T,
    params?: RouteParams[T],
    options: NavigationOptions = {},
  ) => {
    dispatch(
      navigateToRoute({
        routeKey,
        params,
        options,
      }),
    )
  }

  const replaceTo = <T extends RouteKey>(
    routeKey: T,
    params?: RouteParams[T],
    options: NavigationOptions = {},
  ) => {
    navigateTo(routeKey, params, { ...options, replace: true })
  }

  const push = (
    path: string,
    options: {
      includeOrgPrefix?: boolean
      hardRedirect?: boolean
    } = {},
  ) => {
    dispatch(
      navigateToRoute({
        routeKey: 'CUSTOM_PATH' as RouteKey,
        params: { path },
        options,
      }),
    )
  }

  const openInNewTab = (
    path: string,
    options: {
      includeOrgPrefix?: boolean
    } = { includeOrgPrefix: true },
  ) => {
    const organizationName = currentOrganization?.name

    const fullPath = buildRoute(
      'CUSTOM_PATH' as RouteKey,
      { path },
      organizationName,
      options.includeOrgPrefix,
    )

    window.open(fullPath, '_blank')
  }

  return {
    navigateTo,
    replaceTo,
    push,
    openInNewTab,
  }
}
